export const ROUTES = {
    HOME: "/",
    LOCK: "/lock",
    MINT: "/mint",
    DEPOSIT: "/deposit",
    PORTFOLIO: "/portfolio",
    POINTS: "/points",
    VOTE: "/vote",
    DEV: "/dev",
    ACTIVE_POINTS: "/bonus-bytes",
    PASSIVE_POINTS: "/passive-points",
    TERMS: "/terms",
    INTEGRATIONS: "/integrations",
} as const;
